import { h, Fragment } from 'preact';
import { useMemo } from 'preact/hooks';
import clsx from 'clsx';
import Accordion from '../utils/accordion';
import RichText from '../utils/richtext';
import IngredientsList from '../ingredients-list';

export const formatGenericAccordions = (currentProduct) => {
  const formattedAccordions = [];
  if (currentProduct) {
    Array.from(Array(3).keys()).forEach((el) => {
      const formattedAccordion = [];
      formattedAccordion.title =
        currentProduct[`productAccordionTitle${el + 1}`]?.value;
      formattedAccordion.content =
        currentProduct[`productAccordionContent${el + 1}`]?.value;
      formattedAccordions.push(formattedAccordion);
    });
  }
  return formattedAccordions;
};

const Accordions = ({
  currentProduct,
  currentVariant,
  isPdp,
  tryBeforeYouBuy,
}) => {
  const formattedAccordions = formatGenericAccordions(currentProduct);
  const detailAccordionFilled =
    currentProduct?.detailVessel ||
    currentProduct?.detailWeight ||
    currentProduct?.detailDimentions ||
    currentProduct?.detailKeyIngredients ||
    currentProduct?.detailItem;
  const accordionContent = useMemo(
    () => (
      <>
        {currentProduct?.detailVessel?.value && (
          <>
            <p className="font-13-bold mb-1.5">
              {TMW.Strings.accordions.vesselHeading}
            </p>
            <p className="font-13 mb-1.5">
              {currentProduct?.detailVessel?.value}
            </p>
          </>
        )}
        {(currentProduct?.detailWeight?.value ||
          currentProduct?.detailDimentions?.value) && (
          <div className="flex items-start justify-start gap-8 mb-5">
            {currentProduct?.detailWeight?.value && (
              <p
                className={clsx(
                  'font-13',
                  currentProduct?.detailDimentions?.value && 'max-w-[50%]',
                )}
              >
                <span className="font-13-bold">
                  {TMW.Strings.accordions.weightHeading}:
                </span>
                {currentProduct?.detailWeight?.value}
              </p>
            )}
            {currentProduct?.detailDimentions?.value && (
              <p
                className={clsx(
                  'font-13',
                  currentProduct?.detailWeight?.value && 'max-w-[50%]',
                )}
              >
                <span className="font-13-bold">
                  {TMW.Strings.accordions.dimentionsHeading}:
                </span>
                {currentProduct?.detailDimentions?.value}
              </p>
            )}
          </div>
        )}
        {currentProduct.tryBeforeYouBuy?.value === 'true' &&
          tryBeforeYouBuy && <RichText data={JSON.parse(tryBeforeYouBuy)} />}
        {currentProduct?.detailKeyIngredients?.value && (
          <>
            <p className="font-13-bold mb-1.5">
              {TMW.Strings.accordions.keyIngredientsHeading}
            </p>
            <p className="font-13 mb-5">
              {currentProduct?.detailKeyIngredients?.value}
            </p>
          </>
        )}
        {currentVariant?.sku && (
          <>
            <p className="font-13-bold mb-1.5">
              {TMW.Strings.accordions.itemNumberHeading}
            </p>
            <p className="font-13">{currentVariant?.sku}</p>
          </>
        )}
      </>
    ),
    [currentProduct, currentVariant, tryBeforeYouBuy],
  );
  const detailAccordionContent = detailAccordionFilled
    ? accordionContent
    : false;

  return (
    <div className="border-b border-black-30 mb-8">
      <Accordion
        title={TMW.Strings.accordions.detailsHeading}
        content={detailAccordionContent}
        isGeneric={false}
        isPdp={isPdp}
        classes={{
          accordion:
            'gap-5 py-[18px] border-black-30 px-5 laptop:px-0 laptop:pr-2.5 border-t pr-2.5',
          title: 'subheading-h4 text-black',
          content:
            'overflow-hidden max-h-[0px] transition-all duration-300 px-5 laptop:px-0',
        }}
        isRte={false}
      />
      {formattedAccordions.map((accordion, index) => (
        <Accordion
          key={index}
          title={accordion.title}
          content={accordion.content}
          isPdp={isPdp}
          classes={{
            accordion:
              'gap-5 py-[17px] border-black-30 px-5 laptop:px-0 laptop:pr-2.5 border-t pr-2.5',
            title: 'subheading-h4 text-black',
            content:
              'overflow-hidden max-h-[0px] transition-all duration-300 px-5 laptop:px-0',
          }}
        />
      ))}
      <IngredientsList currentProduct={currentProduct} />
    </div>
  );
};

export default Accordions;
